module.exports = __webpack_public_path__ + "static/media/alzaid.df6e9249.jpg";